var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectStreetAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.373 11.6785H5.55957V16.3451H4.3562C4.13157 16.3451 3.95507 16.174 3.95507 15.9562V7.33853L9.5708 1.88638L15.1865 7.33853V10.2598L16.791 11.8185V8.89407L18.0024 10.0685L19.1416 8.96407L10.1404 0.237507C9.82752 -0.0658226 9.31408 -0.0658226 9.0012 0.237507L0 8.96407L1.13919 10.0685L2.35058 8.89407V15.9562C2.35058 17.0295 3.2491 17.9006 4.3562 17.9006H10.9908C10.5816 17.4573 10.373 16.9051 10.373 16.3451V11.6785ZM7.16406 16.3451H8.76855V13.234H7.16406V16.3451ZM18.3955 11.6786H20V17.1229H14.7124L16.556 18.9102L15.4216 20.01L12.2126 16.8989C11.8989 16.5948 11.8989 16.1025 12.2126 15.7992L15.4216 12.6881L16.556 13.7879L14.7204 15.5674H18.3955V11.6786Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectStreetAddress);
export default __webpack_public_path__ + "static/media/redirect-street-address.be26032739771af0b22129f6764b0679.svg";
export { ForwardRef as ReactComponent };